import React,{useState} from 'react'
import './Terms.scss'
import crown from '../../assets/crown.png'
import {faTimes} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import TermsFirst from './terms_first/TermsFirst'
import TermsPay from './terms_payment/TermsPay'
import TermsLoad from './terms_loading/TermsLoad'
import TermsTimer from './terms_timer/TermsTimer'
import TermsToProfile from './terms_toprofile/TermsToProfile'

const BACKGROUND = ["dota--modal" , "molen--modal", "ff--modal", "valor--modal"]

const Terms = ({onClose,bgCover,header,imagelogo}) => {

    const [change,setChange] = useState({id:'', accountName:''})

    const checkBackgroundImage = BACKGROUND.includes(bgCover) ? bgCover : null

    const [showTermsFirst,setShowTermsFirst] = useState(true)
    const [showTermsPay,setShowTermsPay] = useState(true)
    const [showTermsLoad,setShowTermsLoad] = useState(false)
    const [showTermsTimer,setShowTermsTimer] = useState(false)
    const [showTermsToProfile,setShowTermsToProfile] = useState(false)

    const onPay = () => {
        setShowTermsFirst(false)
        setShowTermsPay(false)
        setShowTermsLoad(true)
        setShowTermsTimer(true)
        setShowTermsToProfile(true)
    }

    return (
        <>
        <div className="terms">
            <div className={`terms__container ${checkBackgroundImage}`}>
                <div className="terms__closetag">
                    <div className="terms__closetag-wrap" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} size='lg' className="close"/>
                    </div>     
                </div>

                <div className="terms__content">
                    <div className="terms__content-explain">
                        <div className="terms__content-explain-header">
                            <div className="header-wrap">
                                <p>{header}</p>
                            </div>
                            <div className="image-wrap">
                                <img src={imagelogo} alt="dota"/>
                            </div>                               
                        </div>

                        {showTermsFirst && <TermsFirst/>}
                        {showTermsLoad && <TermsLoad/>}
                        {showTermsTimer && <TermsTimer/>}
                    </div>

                    <div className="line-mark"></div>

                    <div className="terms__content-payment">
                        <div className="terms__content-payment-header">
                            <div className="header-wrap">
                                <p>HI, FUCKING NAME</p>
                            </div>
                            <div className="terms__content-payment-token">
                                <img src={crown} alt="crown"/>
                                <p>25</p>
                            </div>
                        </div>

                        <div className="terms__content-payment-account">
                            <p>Account Detail</p>
                            <p>Id</p>
                            <input 
                                type="text"
                                className="payment-account-id"
                                value={change.id}
                                onChange={(e) => setChange({...change,id:e.target.value})}
                            />
                            <p>Account Name</p>
                            <input 
                                type="text"
                                className="payment-account-name"
                                value={change.accountName}
                                onChange={(e) => setChange({...change,accountName:e.target.value})}
                            />
                        </div>

                        {showTermsPay && <TermsPay onPay={onPay}/>}
                        {showTermsToProfile && <TermsToProfile/>}
                        
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}

export default Terms
